import Text from 'components/elements/text';
import { SeparatorVertical } from 'components/styles';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import ActivityGuestDetailTable from './item-table';
import { ActivityPurchaseFormType } from '../form-type';

interface Props {
  parentIndex: number;
}

export default function ({ parentIndex }: Props) {
  const { control } = useFormContext<ActivityPurchaseFormType>();

  const name = `activityPurchases.${parentIndex}` as const;
  const { activityPurchaseGuests, isGroupedPrice } = useWatch({
    control,
    name,
  });

  if (!activityPurchaseGuests.length) {
    return <></>;
  }

  if (isGroupedPrice) {
    return (
      <ActivityGuestDetailTable
        parentIndex={parentIndex}
        isGroupedPrice
        guestIndex={0}
      />
    );
  }

  return (
    <>
      {activityPurchaseGuests
        .filter((curr) => !!curr.guestId)
        .map((field, idx) => (
          <React.Fragment key={field.customId}>
            <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
            <SeparatorVertical $margin={4} />
            <ActivityGuestDetailTable
              parentIndex={parentIndex}
              guestIndex={idx}
            />
            <SeparatorVertical $margin={8} />
          </React.Fragment>
        ))}
    </>
  );
}
